import React from 'react'
import NoRecordsFound from '../components/NoRecordsFound/index'
import Row from '../components/Row/index'

const CompletedInstancesTable = ({testInstances, selectedInstanceId, onClick, onSort, sortBy, isSortAsc, goToStats, goToClone, compareSelection = [], onToggleCompareSelection}) => {
    const headers = [
        {
          key: "compare",
          name: "Compare",
          sortable: false,
          width: 1
        },
        {
          key: "name",
          name: "Name",
          width: 3
        },
        {
          key: "status",
          name: "Status",
          width: 1,
          sortable: false
        },
        {
          key: "sdkVersion",
          name: "SDK Version",
          width: 2
        },
        {
          key: "sdkBuildNumber",
          name: "Build Number",
          width: 2
        },
        {
          key: "appVersion",
          name: "App Version",
          width: 1
        },
        {
          key: "logs",
          name: "Logs",
          sortable: false,
          width: 1
        },
        {
          key: "stats",
          name: "Stats",
          sortable: false,
          width: 1
        },
        {
            key: "clone",
            name: "Clone",
            sortable: false,
            width: 1
          }
    ]

    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-top" title="Ascending" /> : <span className="glyphicon glyphicon-triangle-bottom" title="Descending"/>

    const renderTableHeaders = () => {
        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }
    
            return (
                <th key={key}  onClick={() => onSort(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
    }

    const statusIcons = {
        Finished: "ok-circle blue",
        Completed: "ok-sign green",
        Cancelled: "ban-circle red",
        Error: "warning-sign red"
    }

    const renderTableRows = () => {
        if (testInstances.length) {
            return testInstances.map(instance => {
                const { name, sdkVersion, sdkBuildNumber, appVersion } = instance
                const hasLogs = instance.devices.some(device => device.hasOwnProperty("logs"))
                const downloadLogsButton = <a className="icon-button" href={"/service/testInstance/" + instance._id + "/logzip"}><span className="glyphicon glyphicon-save" /></a>

                const isSelectedForCompare = compareSelection.includes(instance._id)
                const compareCheckbox = (
                    <span
                        className="compare-checkbox"
                        onClick={event => {
                            event.stopPropagation()
                            if (onToggleCompareSelection) {
                                onToggleCompareSelection(instance._id)
                            }
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={isSelectedForCompare}
                            readOnly
                            aria-label={"Select " + name + " for comparison"}
                        />
                    </span>
                )

                const selectedFields = {
                    compare: compareCheckbox,
                    name,
                    status: <span className={`glyphicon glyphicon-large glyphicon-${statusIcons[instance.status]}`}/>,
                    sdkVersion: sdkVersion ||  <span>-</span> ,
                    sdkBuildNumber: sdkBuildNumber ||  <span>-</span>,
                    appVersion: appVersion ||  <span>-</span>,
                    logs: hasLogs ? downloadLogsButton : <span>-</span>,
                    stats: <span className="table-row__link" onClick={() => goToStats(instance._id)}>STATS</span>,
                    clone: <span className="table-row__link" onClick={() => goToClone(instance._id)}>CLONE</span>
                }

                return (
                    <Row
                        key={instance._id} 
                        data={selectedFields}
                        isActive={selectedInstanceId === instance._id}
                        onClick={() => onClick(instance._id)}
                    />
                )
            })
        }

        return (
            <tr>
                <td colSpan="100%"><NoRecordsFound /></td>
            </tr>
        )
    }

    return (
    <div className="test-instance-list">
        <table className="table">
            <thead className="test-instance-details-head">
                <tr>{ renderTableHeaders() }</tr>
            </thead>
            <tbody>
                { renderTableRows() }
            </tbody>
        </table>
    </div>)
}

export default CompletedInstancesTable